import { 
    GetOrganizationUsers, 
    GetTeams, 
    GetAccounts, 
    GetAppointmentTypes, 
    GetCampaignTypes,
    GetDispositions, 
    GetUsers,
    GetCampaignsLite,
    GetDispositionGroups, 
} from '@/data';
import { GetLoyaltySegments } from '@/data/loyalty_segment';
import { getLanguages } from './language';
import { getUserRoles } from './user';

export const ItemTextValuePairs: Array<any> = [
    { key: 'organization_users',    text: 'organization_name',          value: 'organization_id',       dividerVariable: '',                    expireTimes: 5, getFunc: GetOrganizationUsersData, },
    { key: 'languages',             text: 'key',                        value: 'id',                    dividerVariable: '',                    expireTimes: 1, getFunc: () => { return { value: getLanguages(), error: null }; }, },
    { key: 'user_roles',            text: 'role_name',                  value: 'role_id',               dividerVariable: 'group',               expireTimes: 1, getFunc: () => { return { value: getUserRoles(), error: null }; }, },
    { key: 'loyalty_segments',      text: 'name',                       value: 'id',                    dividerVariable: '',                    expireTimes: 5, getFunc: GetLoyaltySegmentsData, },
    { key: 'teams',                 text: 'name',                       value: 'team_id',               dividerVariable: 'organization_name',   expireTimes: 3, getFunc: GetTeamsData, },
    { key: 'accounts',              text: 'name',                       value: 'account_id',            dividerVariable: '',                    expireTimes: 3, getFunc: GetAccountsData, },
    { key: 'appointment_types',     text: 'name',                       value: 'appointment_type_id',   dividerVariable: '',                    expireTimes: 3, getFunc: GetAppointmentTypesData, },
    { key: 'dispositions',          text: 'disposition_description',    value: 'disposition_id',        dividerVariable: 'group',               expireTimes: 3, getFunc: GetDispositionsData, },
    { key: 'campaign_types',        text: 'name',                       value: 'campaign_type_id',      dividerVariable: '',                    expireTimes: 5, getFunc: GetCampaignTypesData, },
    { key: 'disposition_groups',    text: 'name',                       value: 'disposition_group_id',  dividerVariable: '',                    expireTimes: 3, getFunc: GetDispositionGroupsData, },
    { key: 'campaigns',             text: 'campaign_name',              value: 'campaign_id',           dividerVariable: 'organization_name',   expireTimes: 5, getFunc: GetCampaignsData, },
    { key: 'users',                 text: 'display_name',               value: 'user_id',               dividerVariable: '',                    expireTimes: 3, getFunc: GetUsersData, },
];

export async function GetOrganizationUsersData() {
    return await GetOrganizationUsers().then((response) => {
        return {
            value: response?.Data?.organization_users || [],
            error: response?.Error || null,
        };
    })
};

export async function GetLoyaltySegmentsData() {
    const options = {
        sort_by: 'loyalty_segments_name_asc',
    }

    return await GetLoyaltySegments(options).then((response) => {
        return {
            value: response?.Data?.loyalty_segments || [],
            error: response?.Error || null,
        };
    })
};

export async function GetTeamsData() {
    const options = {
        sort_by: 'teams_name_asc',
    }

    return await GetTeams(options).then((response) => {
        return {
            value: response?.Data?.teams || [],
            error: response?.Error || null,
        };
    })
};

export async function GetAccountsData() {
    const options = {
        sort_by_column_name: 'name',
    }

    return await GetAccounts(options).then((response) => {
        return {
            value: response?.Data?.accounts || [],
            error: response?.Error || null,
        };
    })
};

export async function GetAppointmentTypesData() {
    return await GetAppointmentTypes().then((response) => {
        return {
            value: response?.Data?.appointment_types || [],
            error: response?.Error || null,
        };
    })
};

export async function GetDispositionsData() {
    return await GetDispositions().then((response) => {

        const items = response?.Data?.dispositions || [];
        items.forEach((item) => {
            item.group = 'System';

            if (item.account_id) {
                item.group = 'Account';
            }

            if (item.organization_name) {
                item.group = item.organization_name;
            }
        });

        return {
            value: items || [],
            error: response?.Error || null,
        };
    })
};

export async function GetCampaignTypesData() {
    return await GetCampaignTypes().then((response) => {
        return {
            value: response?.Data?.campaign_types || [],
            error: response?.Error || null,
        };
    })
};

export async function GetDispositionGroupsData() {
    return await GetDispositionGroups({}).then((response) => {
        return {
            value: response?.Data?.disposition_groups || [],
            error: response?.Error || null,
        };
    })
};

export async function GetCampaignsData() {
    return await GetCampaignsLite().then((response) => {
        return {
            value: response?.Data?.campaigns || [],
            error: response?.Error || null,
        };
    })
};

export async function GetUsersData() {
    return await GetUsers().then((response) => {
        return {
            value: response?.Data?.users || [],
            error: response?.Error || null,
        };
    })
};